import { SyncAdapter } from '../LowSync'
import { isEmpty } from 'lodash-es'

export class LocalStorage<T> implements SyncAdapter<T> {
  #key: string

  constructor(key: string) {
    this.#key = key
  }

  read(): T | null {
    const value = global.localStorage.getItem(this.#key)

    if (value === null) {
      return null
    }

    return JSON.parse(value) as T
  }

  write(obj: T): void {
    if (isEmpty(obj)) {
      global.localStorage.removeItem(this.#key)
    } else {
      global.localStorage.setItem(this.#key, JSON.stringify(obj))
    }
  }
}
